import React from 'react';
import { fmtMoney, fmtRate } from '../../utils/priceMath';

/**
 * The order-level REFERENCE numbers from tm_pricing_context.reference (production summary at the
 * quote's rates). A guide for pricing by hand — never a per-line price.
 */
export default function TmReferenceCard({ reference }) {
  if (!reference) return null;
  if (!reference.available) {
    return <div className="alert alert-secondary py-2 small mb-2">{reference.note || 'Reference numbers are unavailable.'}</div>;
  }
  const stations = Array.isArray(reference.stations) ? reference.stations : [];
  return (
    <div className="card mb-2" data-testid="tm-reference">
      <div className="card-header py-1 small fw-bold">Order-level reference, not a per-line price</div>
      <div className="card-body p-2 small">
        <table className="table table-sm mb-1">
          <thead>
            <tr><th>Station</th><th className="text-end">Hours</th><th className="text-end">Rate</th><th className="text-end">Value</th></tr>
          </thead>
          <tbody>
            {stations.map((st) => (
              <tr key={st.workstation}>
                <td>{st.workstation}</td>
                <td className="text-end">{Number(st.actual_hours || 0).toFixed(2)}</td>
                <td className="text-end">{fmtRate(st.rate)}</td>
                <td className="text-end">{fmtMoney(st.value, { dash: true })}</td>
              </tr>
            ))}
            <tr><td colSpan="3">Material × (1 + markup)</td><td className="text-end">{fmtMoney(reference.material_value)}</td></tr>
            <tr><td colSpan="3">Outside finishing × (1 + markup)</td><td className="text-end">{fmtMoney(reference.finishing_value)}</td></tr>
            <tr><td colSpan="3">Laser gas + wear, at cost</td><td className="text-end">{fmtMoney(reference.gas_and_wear_at_cost)}</td></tr>
            <tr className="fw-bold"><td colSpan="3">Reference total</td><td className="text-end">{fmtMoney(reference.reference_total)}</td></tr>
          </tbody>
        </table>
        {reference.note && <div className="text-muted" style={{ fontSize: '0.75rem' }}>{reference.note}</div>}
      </div>
    </div>
  );
}
